module.exports = "static/assets/2bae7059d4f81f344b02cc34567e548d.mp3";